import SelectEventType from './SelectEventType';
import EventInfo from './EventInfo';
import EventDate from './EventDate';
import CaregiverData from './CaregiverData';
import Review from './Review';

const STEPS_COMPONENTS = [
  SelectEventType,
  EventInfo,
  EventDate,
  CaregiverData,
  Review,
];

export default STEPS_COMPONENTS;
